
const i18n = require('../i18n');

const timeAgo = (date) => {

    const t = i18n.default ? i18n.default.t : i18n.t;
    
    const now = new Date();
    const secondsAgo = Math.floor((now - new Date(date)) / 1000);

    if (secondsAgo < 60) {
        return t('time.seconds_ago');
    }

    const minutesAgo = Math.floor(secondsAgo / 60);
    if (minutesAgo < 60) {
        return t('time.minutes_ago', { count: minutesAgo });
    }

    const hoursAgo = Math.floor(minutesAgo / 60);
    if (hoursAgo < 24) {
        return t('time.hours_ago', { count: hoursAgo });
    }

    const daysAgo = Math.floor(hoursAgo / 24);
    if (daysAgo < 30) {
        return t('time.days_ago', { count: daysAgo });
    }

    const monthsAgo = Math.floor(daysAgo / 30);
    if (monthsAgo < 12) {
        return t('time.months_ago', { count: monthsAgo });
    }

    const yearsAgo = Math.floor(monthsAgo / 12);
    return t('time.years_ago', { count: yearsAgo });
};

module.exports = { timeAgo };